import { inviteConstants } from '../_constants';
let item = {};
const initialState = { loading: true, item };

export function invite(state = initialState, action) {
    switch (action.type) {
        case inviteConstants.VALIDATE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case inviteConstants.VALIDATE_SUCCESS:
            return {
                ...state,
                loading:false,
                item: action.invite
            };
        case inviteConstants.VALIDATE_FAILURE:
            return {
                ...state,
                loading:false,
                error: action.error
            };
        case inviteConstants.INVITE_REQUEST:
            return {
                ...state,
                loading: true
            };
        case inviteConstants.INVITE_SUCCESS:
            return {
                ...state,
                loading:false,
                item: action.invite
            };
        case inviteConstants.INVITE_FAILURE:
            return {
                ...state,
                loading:false,
                error: action.error
            };
        default:
            return state
    }
}